import {
  FETCH_QUOTA,
  FETCH_QUOTA_SUCCESS,
  FETCH_QUOTA_ERROR,
  LOAD_MORE_QUOTA,
  LOAD_MORE_QUOTA_SUCCESS,
  LOAD_MORE_QUOTA_ERROR,
  ADD_QUOTA,
  ADD_QUOTA_SUCCESS,
  ADD_QUOTA_ERROR,
  RESET_ADD_QUOTA,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  isShowMore: true,
  updating: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_QUOTA: {
      return {...state, error: '', loading: true, data: []};
    }
    case LOAD_MORE_QUOTA: {
      return {...state, error: '', loading: true};
    }
    case ADD_QUOTA: {
      return {...state, error: '', updating: true};
    }
    case FETCH_QUOTA_SUCCESS: {
      return {...state, error: '', isShowMore: state.data.length < [...state.data, ...action.payload].length, data: action.payload, loading: false};
    }
    case LOAD_MORE_QUOTA_SUCCESS: {
      return {...state, error: '', isShowMore: state.data.length < [...state.data, ...action.payload].length, data: [...state.data, ...action.payload], loading: false};
    }
    case ADD_QUOTA_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case FETCH_QUOTA_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case LOAD_MORE_QUOTA_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_QUOTA_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: action.payload.message || 'Có lỗi trong quá trình xử lý!' }};
    }
    case RESET_ADD_QUOTA: {
      return {...state, payload: {}, data: []};
    }
    default:
      return state;
  }
}
